import { SortableColumn } from 'tea-component/lib/table/addons/sortable';

// ----------- ChartTable组件常量 开始 ------------------
// 排序字段
export const SORT_COLUMNS: SortableColumn[] = [
  { key: 'name', prefer: 'asc' },
  { key: 'label', prefer: 'asc' },
  { key: 'create_time', prefer: 'desc' },
];

// ----------- ChartTable组件常量 结束 ------------------
